<ng-template #notifyModalTpl let-dialogRef="dialogRef">
  <div class="d-flex flex-column justify-content-center align-items-center p-20">
    <div class="mb-30">
      <img src="/img/update.svg">
    </div>

    <h2 class="mb-10">
      Update Notice! 🚀
    </h2>

    <p class="text-center text-neutral-n8 mb-30">Update to fix a bug, improve an existing functionality or uncover a new feature.</p>

    <div class="d-flex justify-content-center w-100 gap-20">
      <button *ngIf="shouldCancelBeShown()" (click)="onUpdateCancel(dialogRef)" class="btn btn-outline-primary px-20 py-10">
        <i class="far fa-clock"></i> Postpone
      </button>
      <button (click)="onClickUpdateButton()" class="btn btn-primary px-20 py-10">
        Update now
      </button>
    </div>
  </div>
</ng-template>
